import { isLocalhost } from '../utils/helpers'

const system = {  appName: 'KolayYolla'

}

if (typeof document !== 'undefined') {
  system.webService = isLocalhost ? 'https://kolayyol-la.ew.r.appspot.com/api' : 'https://kolayyol-la.ew.r.appspot.com/api'
} else if (typeof navigator !== 'undefined' && navigator.product == 'ReactNative') {
  // I'm in react-native
  system.webService = 'https://kolayyol-la.ew.r.appspot.com/api' // TODO CHECK before release
  // system.webService= __DEV__ ? 'http://10.0.0.46:5000/api':'https://kolayyol-la.ew.r.appspot.com/api'
} else {
  // I'm in node js
  system.webService = 'https://kolayyol-la.ew.r.appspot.com/api'
}

export default system
